import React from 'react';
import { Instagram, Facebook } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="bg-[#0A0A0A] text-[#FAFAF8] py-20 px-6 border-t border-white/5" data-id="element-111">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-10" data-id="element-112">
        <div className="text-center md:text-left" data-id="element-113">
          <div className="flex items-center gap-4 mb-6 justify-center md:justify-start" data-id="element-114">
            <div className="w-12 h-12 border border-[#B8956C] flex items-center justify-center" data-id="element-115">
              <span className="font-serif text-2xl font-light tracking-tight" data-id="element-116">
                5П
              </span>
            </div>
            <div data-id="element-117">
              <div className="font-serif text-xl tracking-wide font-medium" data-id="element-118">
                На 5 поверхів
              </div>
              <div className="text-[9px] tracking-[0.25em] uppercase opacity-40 font-light" data-id="element-119">
                Atelier
              </div>
            </div>
          </div>
        </div>

        <div className="flex space-x-10" data-id="element-120">
          <a href="#" className="hover:text-[#B8956C] transition-colors duration-300" data-id="element-121">
            <Instagram size={20} strokeWidth={1.5} data-id="element-122" />
          </a>
          <a href="#" className="hover:text-[#B8956C] transition-colors duration-300" data-id="element-123">
            <Facebook size={20} strokeWidth={1.5} data-id="element-124" />
          </a>
        </div>

        <div className="text-center md:text-right" data-id="element-125">
          <p className="text-xs opacity-30 font-light" data-id="element-126">
            {t('footer.copyright')}
          </p>
        </div>
      </div>
    </footer>;
}